import gql from "graphql-tag";

export default gql`
  mutation DisableUser($id: ID!) {
    updateUser(id: $id, disabled: true) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/DisableUser.ts